import React, { PureComponent } from "react";
import { Collapse } from "reactstrap";
import PropTypes from "prop-types";
import MinusIcon from "mdi-react/MinusIcon";
import PlusIcon from "mdi-react/PlusIcon";
import Tracker from "../analytics/Tracker";

const tracker = new Tracker();

export default class CollapseComponent extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    className: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.onEntering = this.onEntering.bind(this);
    this.onEntered = this.onEntered.bind(this);
    this.onExiting = this.onExiting.bind(this);
    this.onExited = this.onExited.bind(this);
    this.state = { collapse: false, class: "closed", icon: <PlusIcon /> };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  onEntering() {
    this.setState({ class: "closed", icon: <MinusIcon /> });
  }

  onEntered() {
    tracker.handleEvent(tracker.EVENTS.ACTIVATE_COLLAPSE, {
      action: "open",
      label: this.props.title
    });
    this.setState({ class: "closed", icon: <MinusIcon /> });
  }

  onExiting() {
    this.setState({ class: "closed", icon: <PlusIcon /> });
  }

  onExited() {
    tracker.handleEvent(tracker.EVENTS.ACTIVATE_COLLAPSE, {
      action: "close",
      label: this.props.title
    });
    this.setState({ class: "closed", icon: <PlusIcon /> });
  }

  render() {
    let Class = this.props.className ? this.props.className : "";

    return (
      <div className={`collapse__wrapper ${this.state.class} ${Class}`}>
        <div
          key={this.props.idx}
          onClick={this.toggle}
          className="collapse__title risk__progress"
        >
          <p>
            Section {this.props.idx + 1}: {this.props.section} (Click to expand)
          </p>
          {this.props.progress !== 100 ? (
            <span className="incomplete">Section Incomplete</span>
          ) : (
            <span
              className={
                this.props.risk < 11
                  ? "low"
                  : this.props.risk < 51
                  ? "medium"
                  : "high"
              }
            >
              {" "}
              Risk Score: {this.props.risk}
            </span>
          )}
        </div>

        <Collapse
          isOpen={this.state.collapse}
          className="collapse__content"
          onEntering={this.onEntering}
          onEntered={this.onEntered}
          onExiting={this.onExiting}
          onExited={this.onExited}
        >
          <div className="report__headings">
            <p>Section</p>
            <p>Question</p>
            <p>Response</p>
            <p>Insights</p>
            <p>Risk</p>
          </div>
          <div>{this.props.children}</div>
        </Collapse>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Collapse.js